import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx, mergeProps as _mergeProps, withKeys as _withKeys, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "home-container" }
const _hoisted_2 = { class: "app__title pt_0 mt-05" }
const _hoisted_3 = {
  key: 0,
  class: "text--center"
}
const _hoisted_4 = { class: "social-media text-center" }
const _hoisted_5 = { class: "d-flex justify-center" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "material-icons facebook-icon" }, "facebook", -1)
const _hoisted_7 = { class: "text--center mt-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_card = _resolveComponent("el-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_row, { class: "justify-content-login" }, {
      default: _withCtx(() => [
        _createVNode(_component_el_card, { class: "box-card max-w-login" }, {
          default: _withCtx(() => [
            _createElementVNode("h2", _hoisted_2, _toDisplayString(_ctx.$t("login.loginTitle")), 1),
            (_ctx.eventData.themeSettings.logoURL)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _createVNode(_component_el_image, {
                    class: "image__bg",
                    src: _ctx.eventData.themeSettings.logoURL,
                    alt: "event photo",
                    fit: "contain"
                  }, null, 8, ["src"])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.$t("login.signInSocial")), 1),
            _withDirectives(_createElementVNode("div", _hoisted_5, [
              _createElementVNode("button", {
                type: "button",
                class: "login-google mr-1",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.googleLoginAction && _ctx.googleLoginAction(...args)))
              }, " Google "),
              _createElementVNode("button", {
                type: "button",
                class: "login-fb ml-1",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.facebookLoginAction && _ctx.facebookLoginAction(...args)))
              }, [
                _hoisted_6,
                _createTextVNode(" Facebook ")
              ])
            ], 512), [
              [_vShow, false]
            ]),
            _createVNode(_component_el_divider, { "content-position": "center" }, {
              default: _withCtx(() => [
                _withDirectives(_createElementVNode("span", null, _toDisplayString(_ctx.$t("login.or")), 513), [
                  [_vShow, false]
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form, {
              model: _ctx.form,
              ref: "loginform"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, {
                  prop: "email.value",
                  rules: _ctx.form.email.rules
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, _mergeProps({
                      class: "login-input",
                      size: "large",
                      "data-test": "email",
                      placeholder: _ctx.$t('login.emailLabel')
                    }, _ctx.form.email.props, {
                      modelValue: _ctx.form.email.value,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.email.value) = $event))
                    }), null, 16, ["placeholder", "modelValue"])
                  ]),
                  _: 1
                }, 8, ["rules"]),
                _createVNode(_component_el_form_item, {
                  prop: "password.value",
                  rules: _ctx.form.password.rules
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, _mergeProps({
                      rules: _ctx.form.password.props.rules,
                      class: "login-input",
                      size: "large",
                      autocomplete: "off",
                      "data-test": "password"
                    }, _ctx.form.password.props, {
                      placeholder: _ctx.$t('login.passwordLabel'),
                      modelValue: _ctx.form.password.value,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.password.value) = $event)),
                      "show-password": "",
                      onKeyup: _withKeys(_ctx.login, ["enter"])
                    }), null, 16, ["rules", "placeholder", "modelValue", "onKeyup"])
                  ]),
                  _: 1
                }, 8, ["rules"])
              ]),
              _: 1
            }, 8, ["model"]),
            _createVNode(_component_el_row, { type: "flex" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_checkbox, {
                      modelValue: _ctx.rememberMe,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.rememberMe) = $event)),
                      class: "black__base__color"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t("login.rememberMe")), 1)
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, {
                  span: 12,
                  class: "login-forgot secondary__color__link",
                  onClick: _withModifiers(_ctx.goToPasswordRecovery, ["prevent"])
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("login.forgotPassword")), 1)
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_el_button, {
                class: "secondary__color__button",
                onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (_ctx.login()), ["prevent"])),
                type: "primary"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("login.loginButton")), 1)
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}